export const errorMessages = {
  emptyValue: 'שדה לא יכול להישאר ריק',
  invalidValue: 'ערך לא תקין',
  onlyLetters: 'ניתן להזין אותיות בלבד',
  onlyNumbers: 'ניתן להזין ספרות בלבד',
  onlyLettersAndNumbers: 'ניתן להזין אותיות וספרות בלבד',
};

export const regexPatterns = {
  lettersRegex: '^[א-תA-Za-z ."״()-/\'/׳]+$',
  lettersOnlyRegex: '^[א-תA-Za-z\\s]+$',
  lettersAndSymbolsOnly: `^[א-תA-Za-z0-9 "״()-/'׳?]+$`,
  numbersRegex: '^[0-9]+$',
  numbersNotZeroRegex: '^[1-9]{1}\\d*$',
  lettersNumbersRegex: '^[א-תA-Za-z0-9 "״()-/\'/׳]+$',
  lettersNumbersOnlyRegex: '^[א-תA-Za-z0-9 ]+$',
  userNameRegex: '^[A-Za-z0-9 "״()-/\'/׳]+$',
  phoneRegex: '^0(5[012345678]|6[47]){1}(\\-)?[^0\\D]{1}\\d{6}$',
  PhoneExtendedRegex: '^(0(5[012345678]|6[47]){1}(\\-)?[^0\\D]{1}\\d{6}|130\\d{7})$',
  phoneGeneralRegex: '^0[0-9]{8,10}$',
  monthDate: '^(0?[1-9]|1[012])$',
  yearDate: '[0-9][0-9]',
  dateRegex: '^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/[0-9]{4}$',
  paymentLast4Digits: '^[0-9]{4}$',
  emailRegex:
    '^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
  identityRegex: '^\\d{9,10}$',
  bankFileRegex: '^.*.(jpg|JPG|jpeg|JPEG|pdf|PDF|tiff|TIFF|doc|DOC)$',
  positiveNonZeroNumbersRegex: '^[1-9]d*$',
  simActivationCodeRegex: '^[0-9]{10}$',
  hardNameRegex: '^([A-Za-zא-ת' + '"' + "'-]+ )+[A-Za-zא-ת]+$|^[A-Za-zא-ת" + '"' + "'-]+$", //א-ת or a-z or A-Z or "s with (one space or one line "-")
  onlyHebrewLetter: `^([א-ת\\s'])+$`,
  simRegex: '^[0-9]{18}$',
};

export const validationRules = {
  onlyRequired: {
    required: {value: true, error: 'השדה לא יכול להישאר ריק'},
  },
  onlyHebrewLetter: {
    pattern: {value: regexPatterns.onlyHebrewLetter, error: 'שננסה שוב? הפעם רק אותיות בעברית בבקשה'},
  },
  userName: {
    required: {value: true, error: 'לא הוזן שם פרטי'},
    pattern: {value: regexPatterns.lettersOnlyRegex, error: 'ערך לא תקין'},
    minLength: {value: 5, error: 'יש להזין לפחות 5 תווים'},
    maxLength: {value: 50, error: 'השם שהוזן ארוך מדי'},
  },
  fullName: {
    required: {value: true, error: 'יש להזין שם פרטי ושם משפחה'},
    pattern: {value: regexPatterns.lettersOnlyRegex, error: 'ערך לא תקין'},
    minLength: {value: 5, error: 'יש להזין לפחות 5 תווים'},
    maxLength: {value: 50, error: 'השם שהוזן ארוך מדי'},
  },
  email: {
    required: {value: true, error: 'יש להזין כתובת אימייל'},
    pattern: {value: regexPatterns.emailRegex, error: 'ערך לא תקין'},
    minLength: {value: 6, error: 'חובה להזין כתובת אימייל תקינה'},
    maxLength: {value: 320, error: 'חובה להזין כתובת אימייל תקינה'},
  },
  phone: {
    required: {value: true, error: 'אנא הכנס מספר טלפון'},
    pattern: {value: regexPatterns.phoneRegex, error: 'יש להכניס מספר ללא תווים נוספים'},
    minLength: {value: 9, error: 'חובה להזין מספר טלפון תקין'},
    maxLength: {value: 10, error: 'חובה להזין מספר טלפון תקין'},
  },
  PhoneExtended: {
    required: {value: true, error: 'אנא הכנס מספר טלפון'},
    pattern: {value: regexPatterns.PhoneExtendedRegex, error: 'יש להכניס מספר ללא תווים נוספים'},
    minLength: {value: 10, error: 'חובה להזין מספר טלפון תקין'},
    maxLength: {value: 10, error: 'חובה להזין מספר טלפון תקין'},
  },
  phoneExpanded: {
    required: {value: true, error: 'אנא הכנס מספר טלפון'},
    pattern: {value: regexPatterns.phoneExpandedRegex, error: 'ערך לא תקין'},
    minLength: {value: 9, error: 'חובה להזין מספר טלפון תקין'},
    maxLength: {value: 10, error: 'חובה להזין מספר טלפון תקין'},
  },
  phoneStationaryAccepted: {
    required: {value: true, error: 'אנא הכנס מספר טלפון'},
    pattern: {value: regexPatterns.phoneGeneralRegex, error: 'ערך לא תקין'},
    minLength: {value: 9, error: 'חובה להזין מספר טלפון תקין'},
    maxLength: {value: 10, error: 'חובה להזין מספר טלפון תקין'},
  },
  id: {
    required: {value: true, error: 'אנא הכנס ת.ז'},
    pattern: {value: regexPatterns.identityRegex, error: 'ערך לא תקין'},
    minLength: {value: 9, error: 'חובה להזין ערך בן 9 תווים'},
    maxLength: {value: 9, error: 'חובה להזין ערך בן 9 תווים'},
    identity: {value: regexPatterns.numbersRegex, error: 'ערך לא תקין'},
  },
  CardNumber: {
    required: {value: true, error: 'שדה מס אשראי חובה'},
    pattern: {value: regexPatterns.numbersRegex, error: 'ערך לא תקין'},
  },
  CardDueYear: {
    required: {value: true, error: 'לא נבחרה שנה'},
    minLength: {value: 2, error: 'חובה להזין ערך בין 2 תווים'},
    maxLength: {value: 2, error: 'חובה להזין ערך בין 2 תווים'},
    pattern: {value: regexPatterns.yearDate, error: 'ערך לא תקין'},
  },
  CardDueMonth: {
    required: {value: true, error: 'לא נבחר חודש'},
    minLength: {value: 2, error: 'חובה להזין ערך בין 2 תווים'},
    maxLength: {value: 2, error: 'חובה להזין ערך בין 2 תווים'},
    pattern: {value: regexPatterns.monthDate, error: 'ערך לא תקין'},
  },
  CVV: {
    required: {value: true, error: 'לא נבחר '},
    minLength: {value: 3, error: 'חובה להזין ערך בין 3 תווים'},
    maxLength: {value: 3, error: 'חובה להזין ערך בין 3 תווים'},
    pattern: {value: regexPatterns.numbersRegex, error: 'ערך לא תקין'},
  },
  paymentLast4Digits: {
    minLength: {value: 4, error: 'חובה להזין ערך בעל 4 ספרות'},
    maxLength: {value: 4, error: 'חובה להזין ערך בעל 4 ספרות'},
    pattern: {value: regexPatterns.paymentLast4Digits, error: 'ערך לא תקין'},
  },
  BankAccountNo: {
    minLength: {value: 5, error: '  מספר חשבון חייב להכיל לפחות 5 ספרות'},
    maxLength: {value: 12, error: 'מספר חשבון לא יכול להכיל יותר מ12 ספרות'},
    pattern: {value: regexPatterns.numbersRegex, error: 'ערך לא תקין'},
  },
  checkboxRequired: {
    checkboxRequired: {value: true, error: 'שדה חובה'},
  },
  selectIndexNonZero: {
    pattern: {value: regexPatterns.positiveNonZeroNumbersRegex, error: 'שדה חובה'},
  },
  imei: {
    minLength: {value: 15, error: 'חובה להזין ערך בעל 15 תווים'},
    maxLength: {value: 15, error: 'חובה להזין ערך בעל 15 תווים'},
    pattern: {value: regexPatterns.numbersRegex, error: 'ערך לא תקין'},
  },
};
